/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as InvitationsIdRouteImport } from './routes/invitations.$id'
import { Route as OOrgRouteImport } from './routes/o.$org'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations.index'
import { Route as OrganizationsSplatRouteImport } from './routes/organizations.$'
import { Route as PreferencesIndexRouteImport } from './routes/preferences.index'
import { Route as PreferencesSplatRouteImport } from './routes/preferences.$'
import { Route as OOrgIndexRouteImport } from './routes/o.$org.index'
import { Route as OOrgArchiveRouteImport } from './routes/o.$org.archive'
import { Route as OOrgBillingRouteImport } from './routes/o.$org.billing'
import { Route as OOrgMembersRouteImport } from './routes/o.$org.members'
import { Route as OOrgAdminIndexRouteImport } from './routes/o.$org.admin.index'
import { Route as OOrgAdminVersionsRouteImport } from './routes/o.$org.admin.versions'
import { Route as OOrgAnalyticsIndexRouteImport } from './routes/o.$org.analytics.index'
import { Route as OOrgAnalyticsViewIdRouteImport } from './routes/o.$org.analytics.$viewId'
import { Route as OOrgGroupsIndexRouteImport } from './routes/o.$org.groups.index'
import { Route as OOrgGroupsIdRouteImport } from './routes/o.$org.groups.$id'
import { Route as OOrgIdentitiesIndexRouteImport } from './routes/o.$org.identities.index'
import { Route as OOrgIdentitiesIdRouteImport } from './routes/o.$org.identities.$id'
import { Route as OOrgQrCodesIndexRouteImport } from './routes/o.$org.qr-codes.index'
import { Route as OOrgQrCodesIdRouteImport } from './routes/o.$org.qr-codes.$id'
import { Route as OOrgIdentitiesIdIndexRouteImport } from './routes/o.$org.identities.$id.index'
import { Route as OOrgIdentitiesIdEngagementRouteImport } from './routes/o.$org.identities.$id.engagement'
import { Route as OOrgIdentitiesIdIdentityRouteImport } from './routes/o.$org.identities.$id.identity'
import { Route as OOrgQrCodesIdIndexRouteImport } from './routes/o.$org.qr-codes.$id.index'
import { Route as OOrgQrCodesIdAnalyticsRouteImport } from './routes/o.$org.qr-codes.$id.analytics'
import { Route as OOrgQrCodesIdScansRouteImport } from './routes/o.$org.qr-codes.$id.scans'
import { Route as OOrgQrCodesIdSchedulesRouteImport } from './routes/o.$org.qr-codes.$id.schedules'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSplatRoute = AdminSplatRouteImport.update({
  id: '/admin/$',
  path: '/admin/$',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsIdRoute = InvitationsIdRouteImport.update({
  id: '/invitations/$id',
  path: '/invitations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrgRoute = OOrgRouteImport.update({
  id: '/o/$org',
  path: '/o/$org',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsSplatRoute = OrganizationsSplatRouteImport.update({
  id: '/organizations/$',
  path: '/organizations/$',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesIndexRoute = PreferencesIndexRouteImport.update({
  id: '/preferences/',
  path: '/preferences/',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesSplatRoute = PreferencesSplatRouteImport.update({
  id: '/preferences/$',
  path: '/preferences/$',
  getParentRoute: () => rootRouteImport,
} as any)
const OOrgIndexRoute = OOrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgArchiveRoute = OOrgArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgBillingRoute = OOrgBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgMembersRoute = OOrgMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgAdminIndexRoute = OOrgAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgAdminVersionsRoute = OOrgAdminVersionsRouteImport.update({
  id: '/admin/versions',
  path: '/admin/versions',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgAnalyticsIndexRoute = OOrgAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgAnalyticsViewIdRoute = OOrgAnalyticsViewIdRouteImport.update({
  id: '/analytics/$viewId',
  path: '/analytics/$viewId',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgGroupsIndexRoute = OOrgGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgGroupsIdRoute = OOrgGroupsIdRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgIdentitiesIndexRoute = OOrgIdentitiesIndexRouteImport.update({
  id: '/identities/',
  path: '/identities/',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgIdentitiesIdRoute = OOrgIdentitiesIdRouteImport.update({
  id: '/identities/$id',
  path: '/identities/$id',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgQrCodesIndexRoute = OOrgQrCodesIndexRouteImport.update({
  id: '/qr-codes/',
  path: '/qr-codes/',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgQrCodesIdRoute = OOrgQrCodesIdRouteImport.update({
  id: '/qr-codes/$id',
  path: '/qr-codes/$id',
  getParentRoute: () => OOrgRoute,
} as any)
const OOrgIdentitiesIdIndexRoute = OOrgIdentitiesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OOrgIdentitiesIdRoute,
} as any)
const OOrgIdentitiesIdEngagementRoute =
  OOrgIdentitiesIdEngagementRouteImport.update({
    id: '/engagement',
    path: '/engagement',
    getParentRoute: () => OOrgIdentitiesIdRoute,
  } as any)
const OOrgIdentitiesIdIdentityRoute =
  OOrgIdentitiesIdIdentityRouteImport.update({
    id: '/identity',
    path: '/identity',
    getParentRoute: () => OOrgIdentitiesIdRoute,
  } as any)
const OOrgQrCodesIdIndexRoute = OOrgQrCodesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OOrgQrCodesIdRoute,
} as any)
const OOrgQrCodesIdAnalyticsRoute = OOrgQrCodesIdAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => OOrgQrCodesIdRoute,
} as any)
const OOrgQrCodesIdScansRoute = OOrgQrCodesIdScansRouteImport.update({
  id: '/scans',
  path: '/scans',
  getParentRoute: () => OOrgQrCodesIdRoute,
} as any)
const OOrgQrCodesIdSchedulesRoute = OOrgQrCodesIdSchedulesRouteImport.update({
  id: '/schedules',
  path: '/schedules',
  getParentRoute: () => OOrgQrCodesIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/$': typeof AdminSplatRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/o/$org': typeof OOrgRouteWithChildren
  '/organizations/$': typeof OrganizationsSplatRoute
  '/preferences/$': typeof PreferencesSplatRoute
  '/admin/': typeof AdminIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/preferences/': typeof PreferencesIndexRoute
  '/o/$org/archive': typeof OOrgArchiveRoute
  '/o/$org/billing': typeof OOrgBillingRoute
  '/o/$org/members': typeof OOrgMembersRoute
  '/o/$org/': typeof OOrgIndexRoute
  '/o/$org/admin/versions': typeof OOrgAdminVersionsRoute
  '/o/$org/analytics/$viewId': typeof OOrgAnalyticsViewIdRoute
  '/o/$org/groups/$id': typeof OOrgGroupsIdRoute
  '/o/$org/identities/$id': typeof OOrgIdentitiesIdRouteWithChildren
  '/o/$org/qr-codes/$id': typeof OOrgQrCodesIdRouteWithChildren
  '/o/$org/admin/': typeof OOrgAdminIndexRoute
  '/o/$org/analytics/': typeof OOrgAnalyticsIndexRoute
  '/o/$org/groups/': typeof OOrgGroupsIndexRoute
  '/o/$org/identities/': typeof OOrgIdentitiesIndexRoute
  '/o/$org/qr-codes/': typeof OOrgQrCodesIndexRoute
  '/o/$org/identities/$id/engagement': typeof OOrgIdentitiesIdEngagementRoute
  '/o/$org/identities/$id/identity': typeof OOrgIdentitiesIdIdentityRoute
  '/o/$org/qr-codes/$id/analytics': typeof OOrgQrCodesIdAnalyticsRoute
  '/o/$org/qr-codes/$id/scans': typeof OOrgQrCodesIdScansRoute
  '/o/$org/qr-codes/$id/schedules': typeof OOrgQrCodesIdSchedulesRoute
  '/o/$org/identities/$id/': typeof OOrgIdentitiesIdIndexRoute
  '/o/$org/qr-codes/$id/': typeof OOrgQrCodesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/$': typeof AdminSplatRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/organizations/$': typeof OrganizationsSplatRoute
  '/preferences/$': typeof PreferencesSplatRoute
  '/admin': typeof AdminIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/preferences': typeof PreferencesIndexRoute
  '/o/$org/archive': typeof OOrgArchiveRoute
  '/o/$org/billing': typeof OOrgBillingRoute
  '/o/$org/members': typeof OOrgMembersRoute
  '/o/$org': typeof OOrgIndexRoute
  '/o/$org/admin/versions': typeof OOrgAdminVersionsRoute
  '/o/$org/analytics/$viewId': typeof OOrgAnalyticsViewIdRoute
  '/o/$org/groups/$id': typeof OOrgGroupsIdRoute
  '/o/$org/admin': typeof OOrgAdminIndexRoute
  '/o/$org/analytics': typeof OOrgAnalyticsIndexRoute
  '/o/$org/groups': typeof OOrgGroupsIndexRoute
  '/o/$org/identities': typeof OOrgIdentitiesIndexRoute
  '/o/$org/qr-codes': typeof OOrgQrCodesIndexRoute
  '/o/$org/identities/$id/engagement': typeof OOrgIdentitiesIdEngagementRoute
  '/o/$org/identities/$id/identity': typeof OOrgIdentitiesIdIdentityRoute
  '/o/$org/qr-codes/$id/analytics': typeof OOrgQrCodesIdAnalyticsRoute
  '/o/$org/qr-codes/$id/scans': typeof OOrgQrCodesIdScansRoute
  '/o/$org/qr-codes/$id/schedules': typeof OOrgQrCodesIdSchedulesRoute
  '/o/$org/identities/$id': typeof OOrgIdentitiesIdIndexRoute
  '/o/$org/qr-codes/$id': typeof OOrgQrCodesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/admin/$': typeof AdminSplatRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/o/$org': typeof OOrgRouteWithChildren
  '/organizations/$': typeof OrganizationsSplatRoute
  '/preferences/$': typeof PreferencesSplatRoute
  '/admin/': typeof AdminIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/preferences/': typeof PreferencesIndexRoute
  '/o/$org/archive': typeof OOrgArchiveRoute
  '/o/$org/billing': typeof OOrgBillingRoute
  '/o/$org/members': typeof OOrgMembersRoute
  '/o/$org/': typeof OOrgIndexRoute
  '/o/$org/admin/versions': typeof OOrgAdminVersionsRoute
  '/o/$org/analytics/$viewId': typeof OOrgAnalyticsViewIdRoute
  '/o/$org/groups/$id': typeof OOrgGroupsIdRoute
  '/o/$org/identities/$id': typeof OOrgIdentitiesIdRouteWithChildren
  '/o/$org/qr-codes/$id': typeof OOrgQrCodesIdRouteWithChildren
  '/o/$org/admin/': typeof OOrgAdminIndexRoute
  '/o/$org/analytics/': typeof OOrgAnalyticsIndexRoute
  '/o/$org/groups/': typeof OOrgGroupsIndexRoute
  '/o/$org/identities/': typeof OOrgIdentitiesIndexRoute
  '/o/$org/qr-codes/': typeof OOrgQrCodesIndexRoute
  '/o/$org/identities/$id/engagement': typeof OOrgIdentitiesIdEngagementRoute
  '/o/$org/identities/$id/identity': typeof OOrgIdentitiesIdIdentityRoute
  '/o/$org/qr-codes/$id/analytics': typeof OOrgQrCodesIdAnalyticsRoute
  '/o/$org/qr-codes/$id/scans': typeof OOrgQrCodesIdScansRoute
  '/o/$org/qr-codes/$id/schedules': typeof OOrgQrCodesIdSchedulesRoute
  '/o/$org/identities/$id/': typeof OOrgIdentitiesIdIndexRoute
  '/o/$org/qr-codes/$id/': typeof OOrgQrCodesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/$'
    | '/invitations/$id'
    | '/o/$org'
    | '/organizations/$'
    | '/preferences/$'
    | '/admin/'
    | '/organizations/'
    | '/preferences/'
    | '/o/$org/archive'
    | '/o/$org/billing'
    | '/o/$org/members'
    | '/o/$org/'
    | '/o/$org/admin/versions'
    | '/o/$org/analytics/$viewId'
    | '/o/$org/groups/$id'
    | '/o/$org/identities/$id'
    | '/o/$org/qr-codes/$id'
    | '/o/$org/admin/'
    | '/o/$org/analytics/'
    | '/o/$org/groups/'
    | '/o/$org/identities/'
    | '/o/$org/qr-codes/'
    | '/o/$org/identities/$id/engagement'
    | '/o/$org/identities/$id/identity'
    | '/o/$org/qr-codes/$id/analytics'
    | '/o/$org/qr-codes/$id/scans'
    | '/o/$org/qr-codes/$id/schedules'
    | '/o/$org/identities/$id/'
    | '/o/$org/qr-codes/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/$'
    | '/invitations/$id'
    | '/organizations/$'
    | '/preferences/$'
    | '/admin'
    | '/organizations'
    | '/preferences'
    | '/o/$org/archive'
    | '/o/$org/billing'
    | '/o/$org/members'
    | '/o/$org'
    | '/o/$org/admin/versions'
    | '/o/$org/analytics/$viewId'
    | '/o/$org/groups/$id'
    | '/o/$org/admin'
    | '/o/$org/analytics'
    | '/o/$org/groups'
    | '/o/$org/identities'
    | '/o/$org/qr-codes'
    | '/o/$org/identities/$id/engagement'
    | '/o/$org/identities/$id/identity'
    | '/o/$org/qr-codes/$id/analytics'
    | '/o/$org/qr-codes/$id/scans'
    | '/o/$org/qr-codes/$id/schedules'
    | '/o/$org/identities/$id'
    | '/o/$org/qr-codes/$id'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/admin/$'
    | '/invitations/$id'
    | '/o/$org'
    | '/organizations/$'
    | '/preferences/$'
    | '/admin/'
    | '/organizations/'
    | '/preferences/'
    | '/o/$org/archive'
    | '/o/$org/billing'
    | '/o/$org/members'
    | '/o/$org/'
    | '/o/$org/admin/versions'
    | '/o/$org/analytics/$viewId'
    | '/o/$org/groups/$id'
    | '/o/$org/identities/$id'
    | '/o/$org/qr-codes/$id'
    | '/o/$org/admin/'
    | '/o/$org/analytics/'
    | '/o/$org/groups/'
    | '/o/$org/identities/'
    | '/o/$org/qr-codes/'
    | '/o/$org/identities/$id/engagement'
    | '/o/$org/identities/$id/identity'
    | '/o/$org/qr-codes/$id/analytics'
    | '/o/$org/qr-codes/$id/scans'
    | '/o/$org/qr-codes/$id/schedules'
    | '/o/$org/identities/$id/'
    | '/o/$org/qr-codes/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  AdminSplatRoute: typeof AdminSplatRoute
  InvitationsIdRoute: typeof InvitationsIdRoute
  OOrgRoute: typeof OOrgRouteWithChildren
  OrganizationsSplatRoute: typeof OrganizationsSplatRoute
  PreferencesSplatRoute: typeof PreferencesSplatRoute
  AdminIndexRoute: typeof AdminIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  PreferencesIndexRoute: typeof PreferencesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$': {
      id: '/admin/$'
      path: '/admin/$'
      fullPath: '/admin/$'
      preLoaderRoute: typeof AdminSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$id': {
      id: '/invitations/$id'
      path: '/invitations/$id'
      fullPath: '/invitations/$id'
      preLoaderRoute: typeof InvitationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$org': {
      id: '/o/$org'
      path: '/o/$org'
      fullPath: '/o/$org'
      preLoaderRoute: typeof OOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$': {
      id: '/organizations/$'
      path: '/organizations/$'
      fullPath: '/organizations/$'
      preLoaderRoute: typeof OrganizationsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences/': {
      id: '/preferences/'
      path: '/preferences'
      fullPath: '/preferences/'
      preLoaderRoute: typeof PreferencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences/$': {
      id: '/preferences/$'
      path: '/preferences/$'
      fullPath: '/preferences/$'
      preLoaderRoute: typeof PreferencesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$org/': {
      id: '/o/$org/'
      path: '/'
      fullPath: '/o/$org/'
      preLoaderRoute: typeof OOrgIndexRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/archive': {
      id: '/o/$org/archive'
      path: '/archive'
      fullPath: '/o/$org/archive'
      preLoaderRoute: typeof OOrgArchiveRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/billing': {
      id: '/o/$org/billing'
      path: '/billing'
      fullPath: '/o/$org/billing'
      preLoaderRoute: typeof OOrgBillingRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/members': {
      id: '/o/$org/members'
      path: '/members'
      fullPath: '/o/$org/members'
      preLoaderRoute: typeof OOrgMembersRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/admin/': {
      id: '/o/$org/admin/'
      path: '/admin'
      fullPath: '/o/$org/admin/'
      preLoaderRoute: typeof OOrgAdminIndexRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/admin/versions': {
      id: '/o/$org/admin/versions'
      path: '/admin/versions'
      fullPath: '/o/$org/admin/versions'
      preLoaderRoute: typeof OOrgAdminVersionsRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/analytics/': {
      id: '/o/$org/analytics/'
      path: '/analytics'
      fullPath: '/o/$org/analytics/'
      preLoaderRoute: typeof OOrgAnalyticsIndexRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/analytics/$viewId': {
      id: '/o/$org/analytics/$viewId'
      path: '/analytics/$viewId'
      fullPath: '/o/$org/analytics/$viewId'
      preLoaderRoute: typeof OOrgAnalyticsViewIdRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/groups/': {
      id: '/o/$org/groups/'
      path: '/groups'
      fullPath: '/o/$org/groups/'
      preLoaderRoute: typeof OOrgGroupsIndexRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/groups/$id': {
      id: '/o/$org/groups/$id'
      path: '/groups/$id'
      fullPath: '/o/$org/groups/$id'
      preLoaderRoute: typeof OOrgGroupsIdRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/identities/': {
      id: '/o/$org/identities/'
      path: '/identities'
      fullPath: '/o/$org/identities/'
      preLoaderRoute: typeof OOrgIdentitiesIndexRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/identities/$id': {
      id: '/o/$org/identities/$id'
      path: '/identities/$id'
      fullPath: '/o/$org/identities/$id'
      preLoaderRoute: typeof OOrgIdentitiesIdRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/qr-codes/': {
      id: '/o/$org/qr-codes/'
      path: '/qr-codes'
      fullPath: '/o/$org/qr-codes/'
      preLoaderRoute: typeof OOrgQrCodesIndexRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/qr-codes/$id': {
      id: '/o/$org/qr-codes/$id'
      path: '/qr-codes/$id'
      fullPath: '/o/$org/qr-codes/$id'
      preLoaderRoute: typeof OOrgQrCodesIdRouteImport
      parentRoute: typeof OOrgRoute
    }
    '/o/$org/identities/$id/': {
      id: '/o/$org/identities/$id/'
      path: '/'
      fullPath: '/o/$org/identities/$id/'
      preLoaderRoute: typeof OOrgIdentitiesIdIndexRouteImport
      parentRoute: typeof OOrgIdentitiesIdRoute
    }
    '/o/$org/identities/$id/engagement': {
      id: '/o/$org/identities/$id/engagement'
      path: '/engagement'
      fullPath: '/o/$org/identities/$id/engagement'
      preLoaderRoute: typeof OOrgIdentitiesIdEngagementRouteImport
      parentRoute: typeof OOrgIdentitiesIdRoute
    }
    '/o/$org/identities/$id/identity': {
      id: '/o/$org/identities/$id/identity'
      path: '/identity'
      fullPath: '/o/$org/identities/$id/identity'
      preLoaderRoute: typeof OOrgIdentitiesIdIdentityRouteImport
      parentRoute: typeof OOrgIdentitiesIdRoute
    }
    '/o/$org/qr-codes/$id/': {
      id: '/o/$org/qr-codes/$id/'
      path: '/'
      fullPath: '/o/$org/qr-codes/$id/'
      preLoaderRoute: typeof OOrgQrCodesIdIndexRouteImport
      parentRoute: typeof OOrgQrCodesIdRoute
    }
    '/o/$org/qr-codes/$id/analytics': {
      id: '/o/$org/qr-codes/$id/analytics'
      path: '/analytics'
      fullPath: '/o/$org/qr-codes/$id/analytics'
      preLoaderRoute: typeof OOrgQrCodesIdAnalyticsRouteImport
      parentRoute: typeof OOrgQrCodesIdRoute
    }
    '/o/$org/qr-codes/$id/scans': {
      id: '/o/$org/qr-codes/$id/scans'
      path: '/scans'
      fullPath: '/o/$org/qr-codes/$id/scans'
      preLoaderRoute: typeof OOrgQrCodesIdScansRouteImport
      parentRoute: typeof OOrgQrCodesIdRoute
    }
    '/o/$org/qr-codes/$id/schedules': {
      id: '/o/$org/qr-codes/$id/schedules'
      path: '/schedules'
      fullPath: '/o/$org/qr-codes/$id/schedules'
      preLoaderRoute: typeof OOrgQrCodesIdSchedulesRouteImport
      parentRoute: typeof OOrgQrCodesIdRoute
    }
  }
}

interface OOrgIdentitiesIdRouteChildren {
  OOrgIdentitiesIdEngagementRoute: typeof OOrgIdentitiesIdEngagementRoute
  OOrgIdentitiesIdIdentityRoute: typeof OOrgIdentitiesIdIdentityRoute
  OOrgIdentitiesIdIndexRoute: typeof OOrgIdentitiesIdIndexRoute
}

const OOrgIdentitiesIdRouteChildren: OOrgIdentitiesIdRouteChildren = {
  OOrgIdentitiesIdEngagementRoute: OOrgIdentitiesIdEngagementRoute,
  OOrgIdentitiesIdIdentityRoute: OOrgIdentitiesIdIdentityRoute,
  OOrgIdentitiesIdIndexRoute: OOrgIdentitiesIdIndexRoute,
}

const OOrgIdentitiesIdRouteWithChildren =
  OOrgIdentitiesIdRoute._addFileChildren(OOrgIdentitiesIdRouteChildren)

interface OOrgQrCodesIdRouteChildren {
  OOrgQrCodesIdAnalyticsRoute: typeof OOrgQrCodesIdAnalyticsRoute
  OOrgQrCodesIdScansRoute: typeof OOrgQrCodesIdScansRoute
  OOrgQrCodesIdSchedulesRoute: typeof OOrgQrCodesIdSchedulesRoute
  OOrgQrCodesIdIndexRoute: typeof OOrgQrCodesIdIndexRoute
}

const OOrgQrCodesIdRouteChildren: OOrgQrCodesIdRouteChildren = {
  OOrgQrCodesIdAnalyticsRoute: OOrgQrCodesIdAnalyticsRoute,
  OOrgQrCodesIdScansRoute: OOrgQrCodesIdScansRoute,
  OOrgQrCodesIdSchedulesRoute: OOrgQrCodesIdSchedulesRoute,
  OOrgQrCodesIdIndexRoute: OOrgQrCodesIdIndexRoute,
}

const OOrgQrCodesIdRouteWithChildren = OOrgQrCodesIdRoute._addFileChildren(
  OOrgQrCodesIdRouteChildren,
)

interface OOrgRouteChildren {
  OOrgArchiveRoute: typeof OOrgArchiveRoute
  OOrgBillingRoute: typeof OOrgBillingRoute
  OOrgMembersRoute: typeof OOrgMembersRoute
  OOrgIndexRoute: typeof OOrgIndexRoute
  OOrgAdminVersionsRoute: typeof OOrgAdminVersionsRoute
  OOrgAnalyticsViewIdRoute: typeof OOrgAnalyticsViewIdRoute
  OOrgGroupsIdRoute: typeof OOrgGroupsIdRoute
  OOrgIdentitiesIdRoute: typeof OOrgIdentitiesIdRouteWithChildren
  OOrgQrCodesIdRoute: typeof OOrgQrCodesIdRouteWithChildren
  OOrgAdminIndexRoute: typeof OOrgAdminIndexRoute
  OOrgAnalyticsIndexRoute: typeof OOrgAnalyticsIndexRoute
  OOrgGroupsIndexRoute: typeof OOrgGroupsIndexRoute
  OOrgIdentitiesIndexRoute: typeof OOrgIdentitiesIndexRoute
  OOrgQrCodesIndexRoute: typeof OOrgQrCodesIndexRoute
}

const OOrgRouteChildren: OOrgRouteChildren = {
  OOrgArchiveRoute: OOrgArchiveRoute,
  OOrgBillingRoute: OOrgBillingRoute,
  OOrgMembersRoute: OOrgMembersRoute,
  OOrgIndexRoute: OOrgIndexRoute,
  OOrgAdminVersionsRoute: OOrgAdminVersionsRoute,
  OOrgAnalyticsViewIdRoute: OOrgAnalyticsViewIdRoute,
  OOrgGroupsIdRoute: OOrgGroupsIdRoute,
  OOrgIdentitiesIdRoute: OOrgIdentitiesIdRouteWithChildren,
  OOrgQrCodesIdRoute: OOrgQrCodesIdRouteWithChildren,
  OOrgAdminIndexRoute: OOrgAdminIndexRoute,
  OOrgAnalyticsIndexRoute: OOrgAnalyticsIndexRoute,
  OOrgGroupsIndexRoute: OOrgGroupsIndexRoute,
  OOrgIdentitiesIndexRoute: OOrgIdentitiesIndexRoute,
  OOrgQrCodesIndexRoute: OOrgQrCodesIndexRoute,
}

const OOrgRouteWithChildren = OOrgRoute._addFileChildren(OOrgRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  AdminSplatRoute: AdminSplatRoute,
  InvitationsIdRoute: InvitationsIdRoute,
  OOrgRoute: OOrgRouteWithChildren,
  OrganizationsSplatRoute: OrganizationsSplatRoute,
  PreferencesSplatRoute: PreferencesSplatRoute,
  AdminIndexRoute: AdminIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  PreferencesIndexRoute: PreferencesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
